/* src/app/ship/access-points-dialog/access-point-cod-learn-more-dialog/access-point-cod-learn-more-dialog.component.scss */
.dialog-header {
  position: relative;
  border-bottom: solid thin #D9D9D9;
  gap: 20px;
}
.dialog-header .mat-mdc-dialog-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  padding: 0 0 9px 0;
  color: #000000;
}
.dialog-header .close-icon {
  position: absolute;
  top: 0.5em;
  right: -0.5em;
}
.remark {
  color: black;
  font-family: Inter, serif;
  font-size: 0.73125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.5;
}
.dialog-content {
  padding: 0;
}
.dialog-content h3,
.dialog-content p {
  color: #000000;
}
.dialog-content h3 {
  font-size: 0.9375rem;
  font-weight: 600;
  margin-bottom: 0.25em;
}
.dialog-content h3 + p {
  margin-top: 0;
}
.dialog-content a {
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 10px;
  display: inline-block;
}
:host(.access-points-cod-learn-more-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  position: relative;
  padding: 2rem 2.5rem;
}
@media screen and (min-width: 48rem) {
  :host(.access-points-cod-learn-more-dialog) {
    height: auto;
  }
}
/*# sourceMappingURL=access-point-cod-learn-more-dialog.component.css.map */
